import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { updateStepIfDifferent } from '../../helpers/routes';
import * as QuizHelpers from '../../helpers/quiz';

class Household extends Component {
  constructor (props) {
    super(props);
    this.state = {
      household: this.props.quiz.fieldValues.TotalFamilySize,
      message: false,
      animate: ''
    };
    this._nextStep = this._nextStep.bind(this);
  }

  componentDidMount () {
    const p = _.clone(this.props);
    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, 'HH Size');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _handleHhChange (household) {
    if (household.length <= 2) this.props.reducer(household);
  }

  _nextStep () {
    const {quiz, stepMethods} = _.clone(this.props);
    let nextStep;
    if (this.props.route === 'individuals') {
      nextStep = quiz.step + 1;
    } else if (quiz.fieldValues.FamilyType === 'Couple' ||
        quiz.fieldValues.FamilyType === 'Individual') {
      nextStep = quiz.step + 2;
    } else {
      nextStep = quiz.step + 1;
    }

    stepMethods.setStep(nextStep);
  }

  _prevStep () {
    window.history.go(-1);
  }

  _validate (val = this.props.quiz.fieldValues.TotalFamilySize) {
    const isValid = (val.length === 1 && val < 9 && val !== '0');
    if (!isValid) updateStepIfDifferent(this.props.quiz.step);
    return isValid;
  }

  render () {
    const p = _.clone(this.props);
    const {FamilyType, TotalFamilySize} = p.quiz.fieldValues;
    let notice;
    let isEnabled = this._validate(TotalFamilySize);

    if (TotalFamilySize === '0') {
      notice = <p className='alert'>Sorry, you can’t have a household size of zero. Please update.</p>;
    } else if (FamilyType === 'Couple' && TotalFamilySize === '1') {
      notice = (<p className='info'>Are you looking for a <Link to='/individuals/find-a-plan/start'>plan for yourself</Link> rather that you and your spouse?</p>);
      isEnabled = false;
    } else if (FamilyType === 'CoupleChildren' && TotalFamilySize >= 1 && TotalFamilySize < 3) {
      notice = <p className='info'>Sorry, this household size is not possible for your<br /> family type. Please <Link to='/families/find-a-plan/start'>change your selection</Link>.</p>;
      isEnabled = false;
    } else if ((FamilyType === 'IndividualChildren' && TotalFamilySize === '1') || (FamilyType === 'ChildrenOnly' && TotalFamilySize === '1')) {
      notice = <p className='info'>Sorry, this household size is not possible for your<br /> family type. Please <Link to='/families/find-a-plan/start'>change your selection</Link>.</p>;
      isEnabled = false;
    } else if (TotalFamilySize >= 9) {
      notice = <p className='alert'>Sorry, for a household of this size, please give us a call at <a href='tel:518-641-3000'>518-641-3000</a>.</p>;
    }

    return (
      <section className={'p30 animate ' + this.state.animate}>
        <div className='wrap text-center'>
          <h3>How many people live in your household, including&nbsp;you?</h3>
          <p className='form'>
            <input
              id='household'
              type='number'
              autoFocus
              name='TotalFamilySize'
              ref={(input) => { this.household = input; }}
              maxLength='1'
              value={TotalFamilySize}
              onChange={(e) => this._handleHhChange(e.target.value)}
              onKeyUp={(e) => (e.which === 13 && isEnabled && this._nextStep())}
            />
            {this.props.stepMethods.isNextStep() &&
              <button
                className={'btn next ' + isEnabled}
                disabled={!isEnabled}
                onClick={this._nextStep}
              >Next</button>
            }
            <button className='btn back' onClick={this._prevStep}>Previous</button>
          </p>
          <div className={'message' + (notice ? ' show' : '')}>
            {notice}
          </div>
        </div>
      </section>
    );
  }
}

export default Household;
